import styled from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';

var placeholder = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__placeholder",
  componentId: "sc-3wdkji-0"
})(["position:relative;overflow:hidden;border-radius:", ";opacity:", ";transition:opacity ", "ms;transition-timing-function:cubic-bezier(0.5,0,0,1);&:before{content:' ';position:absolute;top:0;right:0;bottom:0;left:50%;width:500%;margin-left:-250%;animation:elemental-ui-placeholder-pulse linear 1s infinite;animation-delay:", "ms;background:", ";}@keyframes elemental-ui-placeholder-pulse{0%{transform:translate3d(-35%,0,0);}100%{transform:translate3d(35%,0,0);}}", ";"], px2rem(4), function (props) {
  return props.$mounted ? 1 : 0;
}, function (props) {
  return props.$fadeIn;
}, function (props) {
  return props.$delay;
}, function (_ref) {
  var pulseColor = _ref.$pulseColor,
    color = _ref.$color;
  return "linear-gradient(to right, ".concat(color, " 30%, ").concat(pulseColor, " 50%, ").concat(color, " 70%) 25% 50%");
}, boxStyles);

export { placeholder };
